module.exports = "<div class=\"g-admin-card\" [ngClass]=\"{'g-bgc-gd-gray': accordion, 'g-admin-disabled': disabled}\">\n  <ng-content></ng-content>\n</div>"